import { DeliveryModeMapped } from '@app-types/delivery';
import { PRICE_TYPE } from '@app-types/price';
import { CartType, Product, SimType } from '@app-types/product';

/**
 * Check all product to find if all are DEFERRED
 * TODO: Create an array of product into cart to have a better structure
 * @param cart current cart
 * @returns true/false
 */
export const hasOnlyDefferedPrice = (cart: CartType): boolean => {
    if (!cart.product) return false;

    const isSimAndDeffered = !cart.sim || (cart.sim && hasZeroOrDeferredPrice(cart.sim));

    const isFeesAndDeffered = !cart.mobileFees || (cart.mobileFees && hasZeroOrDeferredPrice(cart.mobileFees));

    const isDeliveryAndDeffered =
        (cart.deliveryMode && hasZeroOrDeferredPrice(cart.deliveryMode)) || !cart.deliveryMode;

    return isSimAndDeffered && isFeesAndDeffered && isDeliveryAndDeffered;
};

const hasZeroOrDeferredPrice = (item: SimType | DeliveryModeMapped | Product): boolean => {
    let priceType;
    if ('prices' in item) {
        priceType = item.prices.type;
    } else {
        priceType = item.priceType;
    }
    return priceType === PRICE_TYPE.DEFERRED && item?.price >= 0;
};

export const hasPriceTypeProduct = (cart: CartType, type: PRICE_TYPE): boolean => {
    if (!cart.product) return false;

    return (
        cart.sim?.priceType === type || cart.mobileFees?.prices.type === type || cart.deliveryMode?.priceType === type
    );
};
